export default __webpack_public_path__ + "static/media/bold.f147e360.svg";